import { _getLogger } from '@doxyme/analytics';

/**
 * Log all Vonage exceptions to DataDog as warnings.
 *
 * It is recommended to react to errors in completion handlers of specific methods.
 * @see https://tokbox.com/developer/guides/exception-handling/js/#exception_events
 *
 * For now, we want maximum observability around our Vonage integration.
 */
async function setupVonageExceptionLogging() {
  if (typeof window === 'undefined') return; // SSR guard

  const { default: OT } = await import('@opentok/client');

  OT.on('exception', (event) => {
    const logger = _getLogger('Vonage');
    logger.warn('[Vonage/exception]', event.code, event.message);
  });
}

void setupVonageExceptionLogging();
